// extracted by mini-css-extract-plugin
export default {"loading":"FetchLoadingOverlay_loading__WgPZV","text":"FetchLoadingOverlay_text__cR3h9"};